import UserProfile from "./UserProfile";

// The shared profile layout is responsive; mobile only differs by its App shell.
const UserProfileMobile = () => <UserProfile />;

export default UserProfileMobile;
